import { useApolloClient } from "@apollo/client";
import { Group, Text, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { AppContext } from "src/api/AppContext";
import { useTogglableTheme } from "src/utils/theme";

const ClientDashboard = () => {
  const desktopView = useMediaQuery("(min-width: 550px)");
  const { query } = useApolloClient();
  const { currentClient, isDarkMode } = useContext(AppContext);
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const toggleTheme = useTogglableTheme(isDarkMode, theme);

  useEffect(() => {}, []);

  return (
    <Group style={{ alignItems: "flex-start" }}>
      <Text>{"Placeholder"}</Text>
    </Group>
  );
};

export default ClientDashboard;
